export const USERS_AND_GROUPS_LAST_VIEW = 'USERS_AND_GROUPS_LAST_VIEW';
